// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d2p-textarea textarea{font-family:Arial,Microsoft YaHei,微软雅黑,Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,sans-serif}", ""]);
// Exports
module.exports = exports;
